import { render, staticRenderFns } from "./NewsMenu.vue?vue&type=template&id=20870f6c&scoped=true&"
import script from "./NewsMenu.vue?vue&type=script&lang=js&"
export * from "./NewsMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewsMenu.vue?vue&type=style&index=0&id=20870f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20870f6c",
  null
  
)

export default component.exports